import React from 'react'

function AllNotification() {
  return (
    <div>AllNotification</div>
  )
}

export default AllNotification